export const LOAD_INVOICES = "LOAD_INVOICES",
  LOAD_INVOICES_SUCCESS = "LOAD_INVOICES_SUCCESS",
  LOAD_INVOICES_ERROR = "LOAD_INVOICES_ERROR",
  LOAD_MORE_INVOICES = "LOAD_MORE_INVOICES",
  LOAD_MORE_INVOICES_SUCCESS = "LOAD_MORE_INVOICES_SUCCESS",
  LOAD_MORE_INVOICES_ERROR = "LOAD_MORE_INVOICES_ERROR";
